import { useEffect, useState } from "react";
import Navbar from "../../component/common/NavbarProfile";
import Success from "../../assets/images/SuccessFull.png";
import { toast } from "react-toastify";
import {
  CheckIfPaymentAlreadyDone,
  Create_si_and_payment_api,
  Create_si_and_payment_api_for_iframe,
  Submit_si_pmt_entry_store_payerid_touser,
  handleRedirect,
  CloseSaleOrderApi,
} from "../../handlers/Payment/requestpayment";
import { useParams } from "react-router-dom";
//import { Invoice } from "../../handlers/common/api";

// by pv on 2026-02-22
// platform 0 - When using fresh credit card or paynow.
// platform 1 - For bulk booking.
// platform 2 - When using payment link from email.
// platform 3 - When using stored credit card token.

const SuccessfullPage = () => {
  const [showPaymentSuccess, setShowPaymentSuccess] = useState(false);
  const [showPaymentFailed, setShowPaymentFailed] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [venueData, setVenueData] = useState([]);
  const [callonce, setcallonce] = useState(true); //default should br true
  //const [flag, setFlag] = useState(0); // Changed to use state // change back to normal variable
  const { platform, id } = useParams();

  let flag = 0; // default should be 0

  useEffect(() => {
    const venue_data = JSON.parse(localStorage.getItem("venueData")) || {};
    setVenueData(venue_data);
    // Desmond: added this to get company name from cart items
    try {
      const storedCartItems = JSON.parse(localStorage.getItem("cartItems")) || [];
      if (storedCartItems.length > 0 && storedCartItems[0].company) {
        const firstItemCompany = storedCartItems[0].company;
        console.log("First item company:", firstItemCompany);
        localStorage.setItem("company", firstItemCompany);
        // Do something with the company name
      } else {
        console.log("No cart items or company not found");
      }
    } catch (error) {
      console.error("Error parsing cart items:", error);
    }
    // Desmond: end of added this to get company name from cart items

  }, []);
  useEffect(() => {
    if (showPaymentSuccess) {
      localStorage.removeItem("cartItems");
    }
  }, [showPaymentSuccess]);

  const create_si = async (firstPart, data) => {
    console.log("create_si called!!!");
    console.log("firstPart:", firstPart);
    console.log("data:", data);
    // Desmond: Added signature
    localStorage.setItem("signature", data.signature);
    const token = localStorage.getItem("token");

    const venue_data = JSON.parse(localStorage.getItem("venueData")) || {};
    setVenueData(venue_data);
    const SI_Payload = {
      si_details: {
        order_number: firstPart,
        booking_for: venue_data?.booking_for,
        venue: venue_data?.data?.name,
        payment_gateway_response: "Success",
        mid_number: data.mid,
        transaction_id: data.transaction_id,
        payer_id: data.payer_id,
        card_first6: data.first_6,
        card_last4: data.last_4,
        // DESMOND: ADDED MISSING EXP DATE
        exp_date: data.exp_date,
      },
    };

    console.log("SI_Payload:", SI_Payload);
    console.log("callonce: ", callonce);
    console.log("platform: ", platform);

    //pv did this for testing
    //callonce = true;
    //var platform_pv = "0";
    //var callonce_pv = true;
    try {
      console.log("callonce in try: ", callonce);
      console.log("platform in try: ", platform);

      if (callonce) {
        //pv added this for testing
        //var platform_pv = "0";
        if (platform === "0") {
          console.log("Platform 0 - Creating SI and Payment");
          const response = await Create_si_and_payment_api(SI_Payload, token);
          console.log("response 0 - Create_si_and_payment_api", response);
          //console.log("Platform 0 - Checking if payment already done");
          //const res2check = await CheckIfPaymentAlreadyDone(firstPart);

          //if (res2check) {
          if (response) {
            toast.success("Invoice sent to email!");
            console.log(response);
            setcallonce(false);
            localStorage.removeItem("cartItems");
            localStorage.removeItem("countdownEndTime");
            //localStorage.setItem("SiNo", response.data.data.si_number);
          }
        } else if (platform === "1") {
          console.log("Platform 1 - Submitting SI and Payment");
          let payer_id = localStorage.getItem("payer_id");
          let SI_Payer_Payload = {
            ...SI_Payload.si_details,
            si_number: id,
            payer_id,
          };
          console.log("SI_Payer_Payload:", SI_Payer_Payload);
          const response = await Submit_si_pmt_entry_store_payerid_touser(
            SI_Payer_Payload
          );

          if (response) {
            toast.success("Order has been Created!");
            console.log("response 1", response);
            setcallonce(false);
            localStorage.removeItem("cartItems");
            localStorage.removeItem("countdownEndTime");
            //localStorage.setItem("SiNo", response?.data?.data?.si_number);
          }
        } else if (platform === "2") {
          console.log("Platform 2 - Creating SI and Payment for iframe");
          const response = await Create_si_and_payment_api_for_iframe(
            SI_Payload
          );

          if (response) {
            toast.success("Invoice sent to email!");
            console.log(response);
            setcallonce(false);
            localStorage.removeItem("cartItems");
            localStorage.removeItem("countdownEndTime");
            //localStorage.setItem("SiNo", response?.data?.data?.si_number);
          }
        }
      }
    } catch (error) {
      console.log("Error in create_si:", error);
    }
  };

  const fetchTransactionDetails = async (intervalId2) => {
    console.log("Fetching Transaction details");

    const token = localStorage.getItem("token");
    let transaction_id = "";
    if (typeof window !== "undefined" && window.location.search) {
      const searchParams = new URLSearchParams(window.location.search);
      if (searchParams.has("transaction_id")) {
        transaction_id = searchParams.get("transaction_id");
        const [firstPart] = transaction_id.split("_");

        // Desmond: Added venue data here
        const venue_data = JSON.parse(localStorage.getItem("venueData")) || {};
        const mid = localStorage.getItem("request_mid");
        const signature = localStorage.getItem("signature");
        const company = localStorage.getItem("company");
        const payload = {
          request: {
            transaction_id,
            "order_id": firstPart ?? "",
            "booking_for": venue_data?.booking_for ?? "",
            "request_mid": mid ?? "",
            "signature": signature ?? "",
            "company": company ?? "",
          },
        };
        // End of Desmond: Added venue data here

        if (platform === "3") {
          //console.log("Platform 3 - Checking if payment already done");
          const last_4 = localStorage.getItem("last_4");
          const first_6 = localStorage.getItem("first_6");
          const payer_id = localStorage.getItem("payer_id");
          const transaction_id = localStorage.getItem("transaction_id");
          const mid = localStorage.getItem("request_mid");
          // DESMOND: ADDED THIS LINE
          const exp_date = localStorage.getItem("exp_date");

          const token = localStorage.getItem("token");

          const venue_data =
            JSON.parse(localStorage.getItem("venueData")) || {};
          setVenueData(venue_data);
          const SI_Payload = {
            si_details: {
              order_number: firstPart,
              booking_for: venue_data?.booking_for,
              venue: venue_data?.data?.name,
              payment_gateway_response: "Success",
              mid_number: mid,
              transaction_id: transaction_id,
              payer_id: payer_id,
              card_first6: first_6,
              card_last4: last_4,
              // DESMOND: ADDED MISSING EXP DATE
              exp_date: exp_date,
            },
          };

          console.log("Platform 3 - Checking if payment already done");
          const res2check = await CheckIfPaymentAlreadyDone(firstPart);
          console.log("Payment Status for Platform 3 >> ", res2check.data.data.payment_status);
          if (res2check.data.data.payment_status === 0) {
          // DESMOND: ADDED THE LOGIC HERE
          console.log("Platform 3 - Creating SI and Payment");
          const response = await Create_si_and_payment_api(SI_Payload, token);
          console.log("response 3 - Create_si_and_payment_api", response);

          if (response) {
            toast.success("Invoice sent to email!");
            console.log("Response: ", response);
            setcallonce(false);
            localStorage.removeItem("cartItems");
            localStorage.removeItem("countdownEndTime");
            //localStorage.setItem("SiNo", response.data.data.si_number);
          }
          // DESMOND: END OF THE LOGIC
        }

          const res2 = await CheckIfPaymentAlreadyDone(firstPart);
          console.log("Payment Status >> ", res2.data.data.payment_status);
          if (res2.data.data.payment_status === 1) {
            setIsLoading(false);
            setShowPaymentSuccess(true);
            clearInterval(intervalId2);
          }
        } else {
          console.log("Handling redirect for other platforms");
          const res = await handleRedirect(payload);
          console.log("handleRedirect response:", res);

          if (res) {
            localStorage.setItem(
              "payer_id",
              res.data.message.transaction_res.payer_id
            );
          }

          if (
            (res.data.message.transaction_res.response_msg === "successful" ||
              res.data.message.transaction_res.response_msg === "transaction success" ||
              res.data.message.transaction_res.response_msg === "Successful Transaction"
            ) &&
            res.data.message.signature_msg ===
            "signature is fine, continue processing the request" &&
            res.data.message.transaction_res.response_code === "0"
          ) {
            clearInterval(intervalId2);
            setIsLoading(false);
            setShowPaymentSuccess(true);

            if (platform === "1") {
              console.log("Platform 1 - Creating SI");
              create_si(firstPart, res.data.message.transaction_res);
            } else {
              console.log("Checking if payment already done for other platforms");
              const res2 = await CheckIfPaymentAlreadyDone(firstPart, token);
              console.log("CheckIfPaymentAlreadyDone response for platform 1:", res2);

              if (
                // PV took out condition when payment_satus is 1.
                //(res2.data.data.payment_status === 1 && flag === 0) ||
                // DESMOND: Added logic to handle payment_status === 0
                (res2.data.data.payment_status === 0 && flag === 0) ||
                res2.data.data.payment_status === null
              ) {
                create_si(firstPart, res.data.message.transaction_res);

                flag = 1;
                clearInterval(intervalId2);
              }
            }
          } else {
            flag = 100;
            setShowPaymentFailed(true);
            setIsLoading(false);
            toast.error("Transaction Failed");
            clearInterval(intervalId2);

            // Close the sales order when payment fails
            const handleFailedPayment = async () => {
              try {
                const sales_order_id = firstPart;
                console.log("Closing sales order for failed payment - sales_order_id: ", sales_order_id);

                const payload = {
                  sales_order_id: sales_order_id,
                };

                const res = await CloseSaleOrderApi(payload);
                console.log("CloseSaleOrderApi res for failed payment: ", res);

                // Clear cart and related data
                localStorage.removeItem("cartItems");
                localStorage.removeItem("countdownEndTime");

              } catch (error) {
                console.error("Error closing sales order for failed payment:", error);
              }
            };

            handleFailedPayment();
          }
        }
      }
    } else {
      setIsLoading(false);
    }
  };

  // const get_si_from_transa = async (intervalId = null) => {
  //   console.log("get_si_from_transa called");
  //   const searchParams = new URLSearchParams(window.location.search);

  //   const transaction_id = searchParams.get("transaction_id");
  //   console.log("transaction_id:", transaction_id);

  //   const res2 = await get_si_form_tran(transaction_id);
  //   console.log("Response res2 get_si_from_transa", res2);

  //   if (res2?.data?.data?.si_number) {
  //     console.log("SiNo found:", res2.data.data?.si_number);
  //     localStorage.setItem("SiNo", res2.data.data?.si_number);
  //     flag = 1;
  //     //clearInterval(intervalId);
  //   } else {
  //     console.error("SiNo not found in response:", res2);
  //   }
  // };

  // const downloadInvoice = async () => {
  //   console.log("Downloading Invoice");

  //   const SiNo = localStorage.getItem("SiNo");

  //   console.log("Invoice NO>>>>", SiNo);

  //   try {
  //     if (SiNo) {
  //       const a = document.createElement("a");
  //       a.style.display = "none";
  //       a.href = Invoice + `&name=${SiNo}`;
  //       a.download = "invoice.pdf";
  //       a.target = "_blank";
  //       a.rel = "noopener noreferrer";
  //       document.body.appendChild(a);

  //       // Trigger a click event on the anchor to start the download
  //       a.click();

  //       // Clean up: remove the anchor element
  //       document.body.removeChild(a);

  //       toast.success("Invoice Downloaded!");
  //       localStorage.removeItem("cartItems");
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     toast.error("Failed to Download Invoice");
  //   }
  // };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      localStorage.removeItem("role_name");
    }

    let intervalId2 = null;
    //let intervalId = null;

    // Only start intervals if still loading
    if (isLoading) {
      intervalId2 = setInterval(() => {
        fetchTransactionDetails(intervalId2);
      }, 2000);

      // intervalId = setInterval(() => {
      //   get_si_from_transa(intervalId);
      // }, 2000);
    }

    // Cleanup function
    return () => {
      if (intervalId2) clearInterval(intervalId2);
      //if (intervalId) clearInterval(intervalId);
    };
  }, [isLoading, showPaymentSuccess, showPaymentFailed]);

  useEffect(() => {
    // This will trigger the cleanup and restart of the above useEffect
    // when payment status changes, effectively stopping the intervals
  }, [showPaymentSuccess, showPaymentFailed]);

  return (
    <>
      <Navbar />
      {isLoading ? (
        <div className="flex justify-center items-center h-screen">
          <div className="loader"> Loading...</div>
        </div>
      ) : showPaymentFailed ? (
        showPaymentFailed && (
          <div className="max-w-full justify-center items-center flex flex-col my-6 ">
            <div className="text-center mt-14">
              <h1>Payment Failed</h1>

              {console.log("Failed")}
              {/* <p>Booking done Successfully!</p> */}
            </div>
            {/* <div className="relative bg-white mt-10 p-6 rounded-md border border-gray-300 max-w-md mx-auto">
            <div className="text-center">
              <div className="flex flex-col items-center justify-center">
                <div className="rounded-full bg-[#F6E0E1] flex justify-center items-center w-24 h-24">
                  <img
                    src={Success}
                    width={90}
                    height={20}
                    className=""
                    alt="Success"
                  />
                </div>
                <h3 className="mt-4"> Done!</h3>
                <span className="mt-2 mb-8">Booking done Successfully! </span>
                <button
                  type="button"
                  className="px-4 py-2 text-sm font-semibold text-white download-invoice"
                  onClick={downloadInvoice}
                >
                  Download Invoice
                </button>
              </div>
            </div>
          </div> */}
          </div>
        )
      ) : flag !== 100 ? (
        showPaymentSuccess && (
          <div className="max-w-full justify-center items-center flex flex-col my-6 ">
            <div className="text-center mt-14">
              <h1>Payment Successful</h1>
              <p>Booking done Successfully!</p>
            </div>

            <div className="relative bg-white mt-10 p-6 rounded-md border border-gray-300 max-w-md mx-auto">
              <div className="text-center">
                <div className="flex flex-col items-center justify-center">
                  <div className="rounded-full bg-[#F6E0E1] flex justify-center items-center w-24 h-24">
                    <img
                      src={Success}
                      width={90}
                      height={20}
                      className=""
                      alt="Success"
                    />
                  </div>
                  <h3 className="mt-4"> Done!</h3>
                  <span className="mt-2 mb-8">Booking done Successfully! </span>
                  <div><p>
                    Please check your email for the Invoice pdf.
                  </p></div>
                  {/* <button
                    type="button"
                    className="px-4 py-2 text-sm font-semibold text-white download-invoice"
                    onClick={downloadInvoice}
                  >
                    Download Invoice
                  </button> */}
                </div>
              </div>
            </div>
          </div>
        )
      ) : (
        showPaymentFailed && (
          <div className="max-w-full justify-center items-center flex flex-col my-6 ">
            <div className="text-center mt-14">
              <h1>Payment Failed</h1>

              {console.log("Failed")}
              {/* <p>Booking done Successfully!</p> */}
            </div>
            {/* <div className="relative bg-white mt-10 p-6 rounded-md border border-gray-300 max-w-md mx-auto">
              <div className="text-center">
                <div className="flex flex-col items-center justify-center">
                  <div className="rounded-full bg-[#F6E0E1] flex justify-center items-center w-24 h-24">
                    <img
                      src={Success}
                      width={90}
                      height={20}
                      className=""
                      alt="Success"
                    />
                  </div>
                  <h3 className="mt-4"> Done!</h3>
                  <span className="mt-2 mb-8">Booking done Successfully! </span>
                  <button
                    type="button"
                    className="px-4 py-2 text-sm font-semibold text-white download-invoice"
                    onClick={downloadInvoice}
                  >
                    Download Invoice
                  </button>
                </div>
              </div>
            </div> */}
          </div>
        )
      )}
    </>
  );
};

export default SuccessfullPage;
